module.exports = __webpack_public_path__ + "static/media/StarIcon.023e8237.svg";